"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var RailCarIntermodalCoupledDrive = function RailCarIntermodalCoupledDrive(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "54.78",
    height: "24",
    viewBox: "0 0 54.78 24",
    fill: "#93c01f"
  }, props), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "24.46 11.22 24.46 4.19 30.32 7.71 24.46 11.22"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.58,15.42H0V20H8.37a.75.75,0,0,0,.36-.1c0,.11,0,.22,0,.34A3.82,3.82,0,1,0,14.49,17h3.75a3.82,3.82,0,1,0,4,0h4.38a.77.77,0,1,0,0-1.53Zm-17.41,3V17h1.36A3.89,3.89,0,0,0,9.17,18.38Zm5.63,1.81a2.3,2.3,0,1,1-2.29-2.3A2.3,2.3,0,0,1,14.8,20.19Zm7.72,0a2.3,2.3,0,1,1-2.3-2.3A2.3,2.3,0,0,1,22.52,20.19Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.39,16.18a.79.79,0,0,0,.81.77h4.38a3.81,3.81,0,1,0,4,0h3.75a3.8,3.8,0,1,0,5.79,3.24c0-.12,0-.23,0-.34a.75.75,0,0,0,.36.1h8.37V15.42H28.2A.78.78,0,0,0,27.39,16.18ZM44.25,17h1.36v1.43A3.89,3.89,0,0,0,44.25,17Zm-2,.94A2.3,2.3,0,1,1,40,20.19,2.3,2.3,0,0,1,42.27,17.89Zm-7.71,0a2.3,2.3,0,1,1-2.3,2.3A2.3,2.3,0,0,1,34.56,17.89Z"
  }));
};

var _default = RailCarIntermodalCoupledDrive;
exports["default"] = _default;